import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Header from "../Header";
import VertNav from "../VertNav";
import AdminPanelSettingsIcon from "@mui/icons-material/PeopleOutlined";
import Popup from "../Popup";
import { Helmet } from "react-helmet";
import config from "../../../config";
import CircularProgress from "@mui/material/CircularProgress";
import CustomDialog from "../CustomDialog";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    FaTimes,
    FaTrash,
    FaCalendarAlt,
    FaClock,
    FaUserAlt,
    FaSearch,
    FaRegCommentDots,
} from "react-icons/fa";

function getCurrentDate() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
}

const toMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
};

const getTodayISO = () => new Date().toISOString().split("T")[0];

const getTomorrowISO = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
};

const getCurrentMinutes = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};

// const from12To24 = (h, m, ampm) => {
//     let hour = Number(h);
//     if (ampm === "PM" && hour !== 12) hour += 12;
//     if (ampm === "AM" && hour === 12) hour = 0;
//     return hour * 60 + Number(m);
// };
function Appointment() {
    const [services, setServices] = useState([]);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [customerName, setCustomerName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");
    const [bookingDate, setBookingDate] = useState("");
    const [bookingTime, setBookingTime] = useState(""); // Time format: HH:MM AM/PM
    const [selectedHour, setSelectedHour] = useState(""); // New state for selected hour
    const [selectedMinute, setSelectedMinute] = useState(""); // New state for selected minute
    const [selectedAMPM, setSelectedAMPM] = useState("");
    const [presetAppointments, setPresetAppointments] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(true);
    const [bookAppointment, setBookAppointment] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteInvoiceId, setDeleteInvoiceId] = useState(null);
    const sname = localStorage.getItem("sname");
    const branchName = localStorage.getItem("branch_name");
    const [staffData, setStaffData] = useState([]);
    const [service_by, setServiceBy] = useState([]);
    const [userExists, setUserExists] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [customerData, setCustomerData] = useState(null);
    const [api, setAPI] = useState(null);
    const [hasFetchedServices, setHasFetchedServices] = useState(false);
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [anniversaryDate, setAnniversaryDate] = useState(null);
    const [isServiceModalOpen, setServiceModalOpen] = useState(false);
    const [servicesTableData, setServicesTableData] = useState([]);
    const [appointment, setAppointment] = useState([]);
    const [categoryServices, setCategoryServices] = useState([]);
    const [hasFetchedServicesCategory, setHasFetchedServicesCategory] =
        useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [genderFilter, setGenderFilter] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [selectedServiceValues, setSelectedServiceValues] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [customerId, setCustomerId] = useState("");
    const [apiCalled, setApiCalled] = useState(false);
    const mobileInputRef = React.useRef(null);
    const nameInputRef = React.useRef(null);
    const emailInputRef = React.useRef(null);
    const currentDate = getCurrentDate();
    const bid = localStorage.getItem("branch_id");
    const navigate = useNavigate();
    const salonInTime = localStorage.getItem("in_time") || "09:00";
    const salonOutTime = localStorage.getItem("out_time") || "17:00";

    const salonInMin = toMinutes(salonInTime);
    const salonOutMin = toMinutes(salonOutTime);
    const todayISO = getTodayISO();
    const currentMinutes = getCurrentMinutes();

    const isTodaySelected = bookingDate === todayISO;
    const isSalonClosedNow = currentMinutes > salonOutMin;

    // 🔥 min selectable date
    const minBookingDate = isSalonClosedNow ? getTomorrowISO() : todayISO;

    const allowedAmPm = [];
    if (salonInMin < 12 * 60) allowedAmPm.push("AM");
    if (salonOutMin >= 12 * 60) allowedAmPm.push("PM");

    const getAllowedHours = () => {
        // ❌ today selected & salon closed → no hours
        if (isTodaySelected && isSalonClosedNow) {
            return [];
        }

        const hours = [];

        for (let h = 0; h < 24; h++) {
            const hourStart = h * 60;
            const hourEnd = h * 60 + 59;

            // must overlap salon window
            if (hourEnd < salonInMin || hourStart > salonOutMin) continue;

            // if today, block past hours
            if (isTodaySelected && hourEnd < currentMinutes) continue;

            hours.push({
                value: h.toString().padStart(2, "0"),
                label: h.toString().padStart(2, "0"),
            });
        }

        return hours;
    };

    const getAllowedMinutes = () => {
        if (!selectedHour) return [];

        // ❌ today & salon closed → no minutes
        if (isTodaySelected && isSalonClosedNow) {
            return [];
        }

        return ["00", "15", "30", "45"].filter((m) => {
            const totalMin = Number(selectedHour) * 60 + Number(m);

            if (totalMin < salonInMin || totalMin > salonOutMin) return false;

            // if today, block past minutes
            if (isTodaySelected && totalMin <= currentMinutes) return false;

            return true;
        });
    };

    useEffect(() => {
        if (isTodaySelected && isSalonClosedNow) {
            setSelectedHour("");
            setSelectedMinute("");
            setBookingTime("");
        }
    }, [bookingDate]);

    // Update appointment state when services change
    useEffect(() => {
        const newAppointment = [
            ...selectedList.map((service) => ({
                name: service.name,
                category: service.category,
                price: service.price,
                staff: service.staff || service.service_by || "",
                type: service.type,
                isCombo: service.isCombo,
                originalComboName: service.originalComboName,
                isComboService: service.isComboService,
            })),
        ];
        setAppointment(newAppointment);
    }, [selectedList]);

    // Fetch staff data
    const fetchStaffData = async () => {
        const token = localStorage.getItem("token");
        try {
            const staffResponse = await fetch(
                `${config.apiUrl}/api/swalook/staff/?branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!staffResponse.ok) {
                throw new Error("Network response was not ok");
            }

            const staffData = await staffResponse.json();
            const staffArray = Array.isArray(staffData.table_data)
                ? staffData.table_data.map(
                      (staff) => staff.staff_data.staff_name
                  )
                : [];

            setStaffData(staffArray);
        } catch (error) {
            console.error("Error fetching staff data:", error);
            setStaffData(""); // maintain as string
        }
    };

    // Handle time change
    const handleTimeChange = (e) => {
        const { id, value } = e.target;

        if (id === "hours") {
            setSelectedHour(value);
            setSelectedMinute("");
            setBookingTime("");
        }

        if (id === "minutes") {
            setSelectedMinute(value);
            if (selectedHour) {
                setBookingTime(`${selectedHour}:${value}`);
            }
        }
    };

    // Handle adding an appointment
    const handleAddAppointment = async (e) => {
        e.preventDefault();
        setBookAppointment(true);

        let errorMessage = "Please fix the following issues:\n";
        if (services.length === 0)
            errorMessage += " - Select at least one service.\n";

        if (!bookingTime) errorMessage += " - Select a time.\n";
        if (!bookingDate) errorMessage += " - Select a date.\n";
        if (!/^(\+91)?[0-9]{10}$/.test(mobileNo))
            errorMessage += " - Enter a valid mobile number.\n";

        if (errorMessage !== "Please fix the following issues:\n") {
            setDialogTitle("Error");
            setDialogMessage(errorMessage);
            setDialogOpen(true);
            setBookAppointment(false);
            return;
        }

        const token = localStorage.getItem("token");
        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/appointment/?branch_name=${bid}`,
                {
                    customer_name: customerName,
                    mobile_no: mobileNo,
                    email: email,
                    d_o_b: dateOfBirth || "",
                    d_o_a: anniversaryDate || "",
                    service_by: service_by,
                    services: JSON.stringify(appointment),
                    booking_time: bookingTime,
                    booking_date: bookingDate,
                    comment: comments,
                },
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                toast.success("👍Great! Appointment successfully created!", {
                    onClose: () => window.location.reload(), // Refresh page when toast closes
                });
                await addCustomer();

                setShowPopup(true);

                const phoneNumber = `+91${mobileNo}`;
                const serviceNames = services
                    .map((service) => service.name)
                    .join(", ");
                const message = `Hi ${customerName}!\nYour appointment is booked for: ${bookingTime} | ${bookingDate}\nServices: ${serviceNames}\nSee you soon!`;
                const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                    message
                )}`;
                window.open(whatsappLink, "_blank");
            }
        } catch (error) {
            const errorMessage = error.response
                ? error.response.data.message
                : error.message;
            toast.error("Failed to create appointment. Please try again.");
            setShowPopup(true);
        } finally {
            setBookAppointment(false);
        }
    };

    // Handle phone number blur to fetch customer data
    const handlePhoneBlur = async () => {
        try {
            const branchName = localStorage.getItem("branch_id");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${branchName}`,
                {
                    headers: {
                        Authorization: `Token ${localStorage.getItem("token")}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                const userDetailsResponse = await axios.get(
                    `${config.apiUrl}/api/swalook/loyality_program/customer/get_details/?branch_name=${branchName}&mobile_no=${mobileNo}`,
                    {
                        headers: {
                            Authorization: `Token ${localStorage.getItem(
                                "token"
                            )}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const userDataArray = userDetailsResponse.data.data;
                if (Array.isArray(userDataArray) && userDataArray.length > 0) {
                    const userData = userDataArray[0];
                    setUserExists(true);
                    setCustomerName(userData.name || "");
                    setEmail(userData.email || "");
                    setCustomerData(userData);
                    setDateOfBirth(userData.d_o_b);
                    setAnniversaryDate(userData.d_o_a);
                }
            } else {
                setUserExists(false);
            }
        } catch (error) {
            console.error("Error checking membership status:", error);
        }
    };

    // Fetch customer data when mobile number changes
    useEffect(() => {
        if (mobileNo.length === 10) {
            const timeoutId = setTimeout(() => {
                fetchCustomerData();
            }, 500); // Debounce time

            return () => clearTimeout(timeoutId);
        }
    }, [mobileNo]);
    useEffect(() => {
        if (mobileNo.length === 10) {
            handlePhoneBlur();
        }
    }, [mobileNo]);

    const fetchCustomerData = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get-customer-bill-app-data/?mobile_no=${mobileNo}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setCustomerId(response.data);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    // Handle service selection
    const handleServiceSelect = (selected) => {
        setSelectedServiceValues(selected);
        const updatedServiceList = selected.map((service) => ({
            ...service,
            staff: service.staff || [],
            note: service.note || "No notes added",
            category: service.category,
        }));
        setSelectedList(updatedServiceList);
    };

    // Handle combo selection - break down combo into individual services
    const handleComboSelection = (combo) => {
        if (!combo.isCombo || !combo.comboData || !combo.comboData.services) {
            // If it's not a combo or doesn't have services, add as regular service
            toggleServiceSelection(combo);
            return;
        }

        // First add the combo itself as a category header
        const comboHeader = {
            id: combo.id,
            name: combo.name,
            price: combo.price,
            duration: combo.duration,
            category: "Combo",
            type: "combo",
            isCombo: true,
            isComboHeader: true,
            staff: [],
            note: "Combo Package",
        };

        // Create individual services from combo
        const individualServices = combo.comboData.services.map(
            (service, index) => ({
                id: `${combo.id}-service-${index}`,
                name: service.service || "Unnamed Service",
                price: 0, // Individual services in combo don't have separate prices
                duration: service.service_duration || 0,
                for_men: service.for_men !== undefined ? service.for_men : true,
                for_women:
                    service.for_women !== undefined ? service.for_women : true,
                quantity: 1,
                staff: [],
                note: "Part of combo",
                category: "Combo",
                type: "service",
                isComboService: true,
                originalComboName: combo.name,
                comboParentId: combo.id,
            })
        );

        // Add combo header and all individual services to selected list
        const newSelectedList = [
            ...selectedList,
            comboHeader,
            ...individualServices,
        ];
        setSelectedList(newSelectedList);
        setSelectedServiceValues(newSelectedList);
    };

    // Remove combo and all its services
    const removeComboWithServices = (comboId) => {
        const updatedList = selectedList.filter(
            (service) =>
                service.id !== comboId && service.comboParentId !== comboId
        );
        setSelectedList(updatedList);
        setSelectedServiceValues(updatedList);
    };

    // Check if combo is selected
    const isComboSelected = (comboId) => {
        return selectedList.some(
            (service) => service.id === comboId && service.isComboHeader
        );
    };

    // Finalize service selection
    const finalizeSelection = () => {
        setServices(selectedList);
    };

    // Handle delete confirmation
    const handleDeleteConfirm = async () => {
        const token = localStorage.getItem("token");
        try {
            await axios.delete(
                `${config.apiUrl}/api/swalook/delete/appointment/?id=${deleteInvoiceId}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            window.location.reload();
        } catch (error) {
            console.error("Error deleting appointment:", error);
        } finally {
            setShowDeletePopup(false);
        }
    };

    // Handle view details click
    const handleViewDetailsClick = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get-customer-bill-app-data/?mobile_no=${mobileNo}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setCustomerData(response.data);
            setIsPopupVisible(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Handle close popup
    const handleClosePopup = () => {
        window.location.reload();
    };

    // Fetch service category data
    const fetchServiceCategoryData = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${config.apiUrl}/api/swalook/table/services/?branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch categories: ${response.statusText}`
                );
            }

            const result = await response.json();

            if (!result.status || !Array.isArray(result.data)) {
                throw new Error("Invalid API response format");
            }

            // Transform API response into a structured category-service map
            const categoryMap = new Map();

            result.data.forEach((categoryData) => {
                const categoryName =
                    categoryData.category_name || "Uncategorized";

                if (!categoryMap.has(categoryName)) {
                    categoryMap.set(categoryName, {
                        key: categoryName,
                        value: categoryName,
                        services: [],
                    });
                }

                const category = categoryMap.get(categoryName);

                // Process regular services
                if (
                    categoryData.services &&
                    Array.isArray(categoryData.services)
                ) {
                    categoryData.services.forEach((service) => {
                        category.services.push({
                            id: service.id,
                            name: service.service || "Unnamed Service",
                            price: service.service_price || 0,
                            duration: service.service_duration || 0,
                            for_men: service.for_men,
                            for_women: service.for_women,
                            quantity: 1,
                            staff: [],
                            note: "No notes added",
                            category: categoryName,
                            type: "service",
                        });
                    });
                }

                // Process combos
                if (categoryData.combos && Array.isArray(categoryData.combos)) {
                    categoryData.combos.forEach((combo) => {
                        const serviceNames =
                            combo.services && Array.isArray(combo.services)
                                ? combo.services
                                      .map(
                                          (service) =>
                                              service.service ||
                                              "Unnamed Service"
                                      )
                                      .join(", ")
                                : "No services listed";

                        category.services.push({
                            id: `combo-${combo.combo_name}`,
                            name: combo.combo_name,
                            price: combo.combo_price || 0,
                            duration: combo.duration || 0,
                            for_men: true,
                            for_women: true,
                            quantity: 1,
                            staff: [],
                            note: "No notes added",
                            category: categoryName,
                            type: "combo",
                            isCombo: true,
                            comboData: combo,
                            serviceNames: serviceNames,
                        });
                    });
                }
            });

            const categories = Array.from(categoryMap.values());
            setCategoryServices(categories);
            setHasFetchedServicesCategory(true);
        } catch (error) {
            console.error("Error fetching categories:", error.message);
        }
    };

    // Handle gender filter toggle
    const handleGenderFilterToggle = (gender, isChecked) => {
        setGenderFilter((prevFilter) => {
            if (isChecked) {
                return [...prevFilter, gender];
            } else {
                return prevFilter.filter((g) => g !== gender);
            }
        });
    };

    // Filtered categories based on search and gender filter
    const filteredCategories = categoryServices.filter(
        (category) =>
            category.value?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            category.services.some((service) =>
                service.name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
    );

    const handleServiceStaffChange = (serviceId, staffName) => {
        setSelectedList((prevList) =>
            prevList.map((service) =>
                service.id === serviceId
                    ? { ...service, staff: staffName }
                    : service
            )
        );
    };

    // Toggle service selection
    const toggleServiceSelection = (service) => {
        if (selectedList.some((s) => s.id === service.id)) {
            // Remove service - if it's a combo header, remove all related services
            if (service.isComboHeader) {
                removeComboWithServices(service.id);
            } else {
                handleServiceSelect(
                    selectedList.filter((s) => s.id !== service.id)
                );
            }
        } else {
            // Add service - if it's a combo, handle specially
            if (service.isCombo) {
                handleComboSelection(service);
            } else {
                handleServiceSelect([...selectedList, service]);
            }
        }
    };

    // Handle dropdown click
    const handleDropdownClick = () => {
        if (!apiCalled) {
            fetchStaffData();
            setApiCalled(true);
        }
    };

    const handleAllAppointment = (id) => {
        navigate(`/${sname}/${branchName}/view-all-Appointments`);
    };

    const addCustomer = async () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch_id");

        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${branchId}`,
                {
                    name: customerName,
                    mobile_no: mobileNo,
                    email: email || "",
                    d_o_b: dateOfBirth || "",
                    d_o_a: anniversaryDate || "",
                    memberships: [],
                    coupon: [],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            const { status, data } = response;

            if (status >= 200 && status < 300 && data.success) {
                return true;
            } else {
                throw new Error(data.message || "Failed to add customer.");
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "An error occurred.";
            console.error("Error:", error.response?.data || error.message);
            return false;
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
        }).format(amount);
    };

    // Revamped UI components
    const StatsCard = ({ title, value }) => (
        <div className="bg-white p-6 rounded-2xl shadow-sm flex flex-col items-center justify-center">
            <h3 className="text-gray-500 text-sm font-medium">{title}</h3>
            <p className="text-2xl font-bold text-blue-600 mt-2">{value}</p>
        </div>
    );

    const InputField = React.forwardRef(
        (
            {
                label,
                type = "text",
                value,
                onChange,
                placeholder,
                required = false,
                ...props
            },
            ref
        ) => (
            <div className="flex flex-col space-y-1">
                {label && (
                    <label className="text-sm font-medium text-gray-700">
                        {label}
                    </label>
                )}
                <input
                    ref={ref}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition placeholder-gray-900"
                    {...props}
                />
            </div>
        )
    );

    const TimeSelect = ({ id, options, value, onChange, placeholder }) => (
        <select
            id={id}
            value={value}
            onChange={onChange}
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
        >
            <option value="" disabled>
                {placeholder}
            </option>
            {options.map((option) => (
                <option
                    key={option.value || option}
                    value={option.value || option}
                >
                    {option.label || option}
                </option>
            ))}
        </select>
    );

    return (
        <>
            <div className="bg-gray-100">
                <Header />
                <VertNav />
                <div className="md:ml-72 p-6">
                    {/* Customer Stats Section */}
                    {userExists && customerId && (
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                            <StatsCard
                                title="Business"
                                value={formatCurrency(
                                    customerId.total_billing_amount
                                ).replace("₹", "Rs. ")}
                            />
                            <StatsCard
                                title="Appointments"
                                value={customerId.total_appointment}
                            />
                            <StatsCard
                                title="Invoices"
                                value={customerId.total_invoices}
                            />
                            <div className="bg-white p-6 rounded-2xl shadow-sm flex items-center justify-center">
                                <button
                                    onClick={handleViewDetailsClick}
                                    className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
                                >
                                    View Details <span className="ml-2">→</span>
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Main Appointment Form */}
                    <div className="bg-white rounded-2xl shadow-md p-6 mb-8">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                                <FaCalendarAlt className="mr-2 text-blue-500" />
                                Appointment Booking
                            </h2>
                            <button
                                onClick={handleAllAppointment}
                                className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
                            >
                                View All Appointments{" "}
                                <span className="ml-2">→</span>
                            </button>
                        </div>

                        <form
                            onSubmit={handleAddAppointment}
                            className="space-y-6"
                        >
                            {/* Customer Details Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                    <FaUserAlt className="mr-2 text-blue-500" />
                                    Customer Details
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    {/* Phone Number */}
                                    <div className="flex flex-col space-y-1">
                                        <label className="text-sm font-medium text-gray-700">
                                            Phone Number
                                        </label>
                                        <input
                                            ref={mobileInputRef}
                                            type="tel"
                                            value={mobileNo}
                                            onChange={(e) => {
                                                const value =
                                                    e.target.value.replace(
                                                        /\D/g,
                                                        ""
                                                    );
                                                if (value.length <= 10) {
                                                    setMobileNo(value);
                                                    if (value.length === 10) {
                                                        nameInputRef.current?.focus();
                                                    }
                                                }
                                            }}
                                            placeholder="Enter 10-digit mobile number"
                                            required
                                            className="border border-gray-300 rounded-lg px-4 py-2 placeholder-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                        />
                                    </div>

                                    {/* Full Name */}
                                    <div className="flex flex-col space-y-1">
                                        <label className="text-sm font-medium text-gray-700">
                                            Full Name
                                        </label>
                                        <input
                                            ref={nameInputRef}
                                            type="text"
                                            value={customerName}
                                            onChange={(e) =>
                                                setCustomerName(e.target.value)
                                            }
                                            placeholder="Customer full name"
                                            required
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    emailInputRef.current?.focus();
                                                }
                                            }}
                                            className="border placeholder-gray-900 border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                        />
                                    </div>

                                    {/* Email Address */}
                                    <div className="flex flex-col space-y-1">
                                        <label className="text-sm font-medium text-gray-700">
                                            Email Address
                                        </label>
                                        <input
                                            ref={emailInputRef}
                                            type="email"
                                            value={email}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                            placeholder="Customer email"
                                            readOnly={userExists}
                                            className="border placeholder-gray-900 border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                                    <InputField
                                        label="Date of Birth"
                                        type="date"
                                        value={dateOfBirth}
                                        onChange={(e) =>
                                            !userExists &&
                                            setDateOfBirth(e.target.value)
                                        }
                                        max={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                    />
                                    <InputField
                                        label="Date of Anniversary"
                                        type="date"
                                        value={anniversaryDate}
                                        onChange={(e) =>
                                            !userExists &&
                                            setAnniversaryDate(e.target.value)
                                        }
                                        max={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                    />
                                </div>
                            </div>

                            {/* Services Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                    Services Selection
                                </h3>

                                <button
                                    type="button"
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center transition"
                                    onClick={() => {
                                        setServiceModalOpen(true);
                                        fetchServiceCategoryData();
                                    }}
                                >
                                    <span>+</span>
                                    <span className="ml-2">Add Services</span>
                                </button>

                                {selectedList.length > 0 && (
                                    <div className="mt-6">
                                        <h4 className="text-md font-medium text-gray-700 mb-3">
                                            Selected Services (
                                            {selectedList.length})
                                        </h4>

                                        <div className="overflow-x-auto">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            #
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Service
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Price
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Duration
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Staff
                                                        </th>
                                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Actions
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {selectedList.map(
                                                        (service, index) => (
                                                            <tr
                                                                key={service.id}
                                                                className={
                                                                    service.isComboHeader
                                                                        ? "bg-blue-50 font-semibold"
                                                                        : service.isComboService
                                                                        ? "bg-blue-25"
                                                                        : ""
                                                                }
                                                            >
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {index + 1}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                    <div className="flex flex-col">
                                                                        <span>
                                                                            {
                                                                                service.name
                                                                            }
                                                                        </span>
                                                                        {service.isComboService && (
                                                                            <span className="text-xs text-gray-500">
                                                                                (Part
                                                                                of:{" "}
                                                                                {
                                                                                    service.originalComboName
                                                                                }

                                                                                )
                                                                            </span>
                                                                        )}
                                                                        {service.isComboHeader && (
                                                                            <span className="text-xs text-blue-600 font-medium">
                                                                                COMBO
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                                                    {service.isComboService ? (
                                                                        <span className="text-gray-400">
                                                                            -
                                                                        </span>
                                                                    ) : (
                                                                        `₹${service.price}`
                                                                    )}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {
                                                                        service.duration
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500">
                                                                    {!service.isComboHeader && (
                                                                        <select
                                                                            onClick={
                                                                                handleDropdownClick
                                                                            }
                                                                            value={
                                                                                service.staff ||
                                                                                ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handleServiceStaffChange(
                                                                                    service.id,
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            }
                                                                            className="border border-gray-300 rounded-md px-2 py-1 text-sm"
                                                                        >
                                                                            <option value="">
                                                                                Select
                                                                                Staff
                                                                            </option>
                                                                            {staffData.map(
                                                                                (
                                                                                    staff,
                                                                                    idx
                                                                                ) => (
                                                                                    <option
                                                                                        key={
                                                                                            idx
                                                                                        }
                                                                                        value={
                                                                                            staff
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            staff
                                                                                        }
                                                                                    </option>
                                                                                )
                                                                            )}
                                                                        </select>
                                                                    )}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    <button
                                                                        onClick={() =>
                                                                            toggleServiceSelection(
                                                                                service
                                                                            )
                                                                        }
                                                                        className="text-red-500 hover:text-red-700"
                                                                    >
                                                                        <FaTrash
                                                                            size={
                                                                                16
                                                                            }
                                                                        />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Schedule Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                    <FaClock className="mr-2 text-blue-500" />
                                    Schedule Appointment
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                    <InputField
                                        label="Date"
                                        type="date"
                                        id="date"
                                        value={bookingDate}
                                        onChange={(e) =>
                                            setBookingDate(e.target.value)
                                        }
                                        min={minBookingDate}
                                    />

                                    <div className="flex flex-col space-y-1">
                                        <label className="text-sm font-medium text-gray-700">
                                            Time
                                        </label>
                                        <div className="flex space-x-2">
                                            <TimeSelect
                                                id="hours"
                                                value={selectedHour}
                                                onChange={handleTimeChange}
                                                placeholder="Hour"
                                                options={getAllowedHours()}
                                                required
                                            />

                                            <TimeSelect
                                                id="minutes"
                                                value={selectedMinute}
                                                onChange={handleTimeChange}
                                                placeholder="Min"
                                                options={getAllowedMinutes()}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Comments Section */}
                            <div className="bg-gray-50 p-6 rounded-xl">
                                <h3 className="font-semibold text-lg text-gray-700 mb-4 flex items-center">
                                    <FaRegCommentDots
                                        className="mr-2 text-blue-400"
                                        aria-hidden="true"
                                    />
                                    Comments:
                                </h3>
                                <textarea
                                    placeholder="Enter any additional comments..."
                                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition min-h-[100px]"
                                    value={comments}
                                    onChange={(e) =>
                                        setComments(e.target.value)
                                    }
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-center pt-4">
                                <button
                                    type="submit"
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-8 rounded-lg shadow-md transition flex items-center"
                                    disabled={bookAppointment}
                                >
                                    {bookAppointment ? (
                                        <>
                                            <CircularProgress
                                                size={20}
                                                color="inherit"
                                                className="mr-2"
                                            />
                                            Processing...
                                        </>
                                    ) : (
                                        "Confirm Appointment"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Service Selection Modal */}
            {isServiceModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                        {/* Modal Header */}
                        <div className="flex justify-between items-center border-b p-4">
                            <h3 className="text-xl font-bold text-gray-800">
                                Select Services
                            </h3>
                            <button
                                onClick={() => setServiceModalOpen(false)}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                <FaTimes size={24} />
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="p-4 overflow-y-auto flex-grow">
                            {/* Search and Filters */}
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                                <div className="relative flex-grow">
                                    <FaSearch className="absolute left-3 top-3 text-gray-400" />
                                    <input
                                        type="text"
                                        placeholder="Search services..."
                                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                        value={searchQuery}
                                        onChange={(e) =>
                                            setSearchQuery(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="flex items-center space-x-4">
                                    {["Male", "Female"].map((gender) => (
                                        <label
                                            key={gender}
                                            className="flex items-center space-x-2"
                                        >
                                            <input
                                                type="checkbox"
                                                checked={genderFilter.includes(
                                                    gender
                                                )}
                                                onChange={(e) =>
                                                    handleGenderFilterToggle(
                                                        gender,
                                                        e.target.checked
                                                    )
                                                }
                                                className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                            />
                                            <span className="text-sm text-gray-700">
                                                {gender}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* Services Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {filteredCategories.map((category) => (
                                    <div
                                        key={category.key}
                                        className="border border-gray-200 rounded-lg overflow-hidden"
                                    >
                                        <div className="bg-gray-100 px-4 py-3 border-b">
                                            <h4 className="font-semibold text-gray-800">
                                                {category.value}
                                            </h4>
                                        </div>
                                        <ul className="divide-y divide-gray-200">
                                            {category.services
                                                .filter((service) => {
                                                    if (
                                                        genderFilter.length ===
                                                        0
                                                    )
                                                        return true;
                                                    if (
                                                        genderFilter.includes(
                                                            "Male"
                                                        ) &&
                                                        genderFilter.includes(
                                                            "Female"
                                                        )
                                                    ) {
                                                        return true;
                                                    } else if (
                                                        genderFilter.includes(
                                                            "Male"
                                                        )
                                                    ) {
                                                        return service.for_men;
                                                    } else if (
                                                        genderFilter.includes(
                                                            "Female"
                                                        )
                                                    ) {
                                                        return service.for_women;
                                                    }
                                                    return false;
                                                })
                                                .map((service) => (
                                                    <li
                                                        key={service.id}
                                                        className="px-4 py-3 hover:bg-gray-50"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <label className="flex items-center space-x-3 cursor-pointer">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        isComboSelected(
                                                                            service.id
                                                                        ) ||
                                                                        selectedList.some(
                                                                            (
                                                                                s
                                                                            ) =>
                                                                                s.id ===
                                                                                service.id
                                                                        )
                                                                    }
                                                                    onChange={() =>
                                                                        toggleServiceSelection(
                                                                            service
                                                                        )
                                                                    }
                                                                    className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                />
                                                                <div className="flex flex-col">
                                                                    <span className="text-sm font-medium text-gray-700">
                                                                        {
                                                                            service.name
                                                                        }
                                                                        {service.isCombo && (
                                                                            <span className="text-xs text-gray-500 ml-1">
                                                                                (Combo)
                                                                            </span>
                                                                        )}
                                                                    </span>
                                                                    {service.isCombo &&
                                                                        service.serviceNames && (
                                                                            <span className="text-xs text-gray-500 mt-1">
                                                                                (
                                                                                {
                                                                                    service.serviceNames
                                                                                }

                                                                                )
                                                                            </span>
                                                                        )}
                                                                </div>
                                                            </label>
                                                            <span className="text-sm font-semibold text-gray-700">
                                                                ₹{service.price}
                                                            </span>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="border-t p-4 bg-gray-50">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm text-gray-600">
                                        Selected:{" "}
                                        <span className="font-medium">
                                            {selectedList.length} services
                                        </span>
                                    </p>
                                    {selectedList.length > 0 && (
                                        <p className="text-xs text-gray-500 mt-1">
                                            {selectedList
                                                .map((s) => s.name)
                                                .join(", ")}
                                        </p>
                                    )}
                                </div>
                                <button
                                    onClick={() => {
                                        finalizeSelection(selectedList);
                                        setServiceModalOpen(false);
                                    }}
                                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium"
                                >
                                    Add Services
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Customer Details Popup */}
            {isPopupVisible && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                        <div className="flex justify-between items-center border-b p-4">
                            <h2 className="text-xl font-bold text-gray-800">
                                Customer Appointment History
                            </h2>
                            <button
                                onClick={handleClosePopup}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                <FaTimes size={24} />
                            </button>
                        </div>

                        <div className="p-4 overflow-y-auto flex-grow">
                            {customerData ? (
                                <div className="overflow-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-100">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Name
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Mobile
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Time
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Date
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Services
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {customerData.previous_appointments
                                                ?.length > 0 ? (
                                                customerData.previous_appointments.map(
                                                    (item, index) => (
                                                        <tr
                                                            key={index}
                                                            className={
                                                                index % 2 === 0
                                                                    ? "bg-white"
                                                                    : "bg-gray-50"
                                                            }
                                                        >
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                                                {
                                                                    customerData.customer_name
                                                                }
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                {
                                                                    customerData.customer_mobile_no
                                                                }
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                {item.time}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                {item.Date}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-gray-500">
                                                                {(() => {
                                                                    try {
                                                                        const services =
                                                                            JSON.parse(
                                                                                item.services
                                                                            );
                                                                        return services.map(
                                                                            (
                                                                                service,
                                                                                idx
                                                                            ) => (
                                                                                <div
                                                                                    key={
                                                                                        idx
                                                                                    }
                                                                                    className="mb-1 last:mb-0"
                                                                                >
                                                                                    •{" "}
                                                                                    {
                                                                                        service.Description
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        );
                                                                    } catch (error) {
                                                                        return (
                                                                            <div>
                                                                                {
                                                                                    item.services
                                                                                }
                                                                            </div>
                                                                        );
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    )
                                                )
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="5"
                                                        className="px-4 py-4 text-center text-sm text-gray-500"
                                                    >
                                                        No appointment history
                                                        found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="flex justify-center items-center h-32">
                                    <CircularProgress size={24} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}

export default Appointment;
